//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum AddQuoteSupportRequestState {
  Created = 0,
  DuplicateRequest = 1
}

export interface Address {
  line1: string | null;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string | null;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export interface BaseLogin {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  systemUserId: string;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
  claims: { [key: string]: string } | null;
}

export enum ConversationState {
  Resolved = 0,
  Cancelled = 1,
  ReActivated = 2
}

export interface DealerDeployment {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  active: boolean;
  deploymentType: DeploymentType;
  securityAccessToken: string | null;
  name: string | null;
  comment: string | null;
  apiDomain: string | null;
  uiDomain: string | null;
  deploymentLicenceeId: number;
  azureBlobConnectionString: string | null;
  limitedAccessAzureStorageConnectionString: string | null;
  azureBlobSASReadToken: string | null;
  azureBlobSASWriteToken: string | null;
  azureBlobDomain: string | null;
  systemType: DealerDeploymentSystemType;
  operationType: DealerDeploymentOperationType;
}

export enum DealerDeploymentOperationType {
  Production = 0,
  Test = 1
}

export enum DealerDeploymentSystemType {
  V6 = 0,
  V7 = 1
}

export interface DeploymentFranchiseeBranch {
  dateCreated: string;
  id: string;
  recordVersion: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  taxRegistrationNumber: string | null;
  abbreviation: string;
  name: string;
  physicalAddress: Address;
  billingAddress: Address | null;
  physicalAddressAsDefaultShipping: boolean;
}

export interface DeploymentFranchiseeConfiguration {
  dateCreated: string;
  id: string;
  recordVersion: string;
  globalSupplierReferenceId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  defaultPricingRuleId: string;
}

export interface DeploymentTenantLicensePool {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  name: string | null;
  concurrentUsers: number;
  dateExpires: string;
  dealerDeploymentId: number;
  dealerDeployment: DealerDeployment | null;
  licenseOwnerType: LicenseOwnerType;
  licenseOwnerName: string | null;
  licenseOwnerId: number;
}

export enum DeploymentType {
  SingleSupplierOwnerOperator = 0,
  SingleSupplierManaged = 2,
  MultiSupplierManaged = 4,
  SupplierInterface = 8,
  SingleSupplierInterface = 16
}

export interface GlobalSupplierReference {
  dateCreated: string;
  id: string;
  recordVersion: string;
  supplierTenantId: number;
  licenseServerId: number;
}

export interface InputAddQuoteSupportRequest {
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  quoteId: string;
  quoteSetId: string;
  franchiseeSystemUserId: string;
  type: SupportInboxItemType;
  conversationId: string;
  subject: string;
  note: string | null;
  other: { [key: string]: string };
}

export interface InputCreateFranchisee {
  requestOnBoardTenant: RequestOnBoardTenant;
  defaultPricingRuleId: string;
}

export interface InputFranchiseeBranch {
  dateCreated: string | null;
  branchId: string;
  taxRegistrationNumber: string | null;
  name: string;
  abbreviation: string;
  physicalAddress: Address;
  billingAddress: Address | null;
  physicalAddressAsDefaultShipping: boolean;
}

export interface InputSetNewQuotesAndPurchaseOrdersForSupplier {
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  deploymentId: number;
  quotes: QuoteDTO[];
  purchaseOrders: PurchaseOrderDTO[];
}

export interface InputSyncBranches {
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  deploymentId: number;
  branches: InputFranchiseeBranch[];
}

export interface InputUpdateFranchiseeDeploymentConfiguration {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
}

export interface InputUpdateFranchiseeSupplierProperties {
  deploymentFranchiseeConfigurationId: string;
  maxLicensePoolAllocation: number | null;
  primaryContact: BaseLogin | null;
  defaultV6Reference: string | null;
  primaryContactPhoneNumber: string | null;
  primaryContactEmail: string | null;
}

export interface InputUpdateSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeploymentId: number;
  referenceOverrides: { [key: string]: string } | null;
}

export interface InputUpdateSupportInboxItem {
  id: string;
  status: SupportInboxItemStatus | null;
  assignedUserId: string | null;
}

export interface InputUpdateSupportInboxItemForConversation {
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  quoteId: string;
  conversationId: string;
  updatedByUserId: string;
  isUpdatedBySupplier: boolean;
  state: ConversationState | null;
  subject: string;
  ticketCreated: string;
}

export interface InputUpdateSupportInboxItemForQuoteReview {
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  quoteId: string;
  quoteSetId: string;
  status: SupportInboxItemStatus | null;
}

export enum LicenseOwnerType {
  Internal = 0,
  Tenant = 1,
  Supplier = 2,
  Managed = 4
}

export interface PurchaseOrderAggregated {
  dateCreated: string;
  recordVersion: string;
  tenantId: number;
  supplierId: string;
  deploymentId: number;
  branchId: string;
  quoteId: string;
  id: string;
  title: string | null;
  purchaseOrderNumber: number;
  reference: string | null;
  state: number;
  installationDate: string | null;
  calculatedNettTotal: number;
  calculatedAdjustmentTotal: number;
  supplierSystemClosedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemStatus: string | null;
  tenantRecordVersion: string | null;
  assignedToUserId: string;
  creationUserId: string;
  lastModifiedUserId: string;
}

export interface PurchaseOrderDTO {
  id: string;
  branchId: string;
  quoteId: string;
  title: string;
  purchaseOrderNumber: number;
  reference: string;
  state: number;
  installationDate: string | null;
  calculatedNettTotal: number;
  supplierSystemClosedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemStatus: string | null;
  calculatedAdjustmentTotal: number;
  recordVersion: string;
  assignedToUserId: string;
  creationUserId: string;
  lastModifiedUserId: string;
}

export interface PurchaseOrderSummary {
  franchiseeTenantId: number;
  id: string;
  quoteId: string;
  branchId: string;
  title: string | null;
  purchaseOrderNumber: number;
  reference: string | null;
  installationDate: string | null;
  calculatedNettTotal: number;
  calculatedAdjustmentTotal: number;
  supplierSystemDeliveryDate: string | null;
  quoteNumber: number;
  quoteSuffix: string;
  supplierSystemStatus: string | null;
}

export interface QuoteAggregated {
  recordVersion: string;
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  branchId: string;
  id: string;
  quoteSetId: string;
  title: string | null;
  state: number;
  quoteNumber: number;
  quoteSuffix: string;
  quoteType: number;
  dateCreated: string;
  validUntilDate: string | null;
  installationDate: string | null;
  lastModifiedDate: string;
  lastModifiedUserId: string;
  tenantRecordVersion: string | null;
  calculatedGrossTotal: number;
  creationUserId: string;
  assignedToUserId: string;
}

export interface QuoteDTO {
  id: string;
  quoteSetId: string;
  branchId: string;
  title: string;
  state: number;
  quoteType: number;
  quoteNumber: number;
  quoteSuffix: string;
  dateCreated: string;
  lastModifiedDate: string;
  lastModifiedUserId: string;
  creationUserId: string;
  validUntilDate: string | null;
  installationDate: string | null;
  recordVersion: string;
  calculatedGrossTotal: number;
  assignedToUserId: string;
}

export interface RequestCurrentRecordVersion {}

export interface RequestDataExportFranchisees {}

export interface RequestDataExportPurchaseOrders {
  pageSize: number | null;
  pageIndex: number | null;
  recordVersion: string | null;
}

export interface RequestDataExportQuotes {
  pageSize: number | null;
  pageIndex: number | null;
  recordVersion: string | null;
}

export interface RequestGetActiveUserInformation {
  systemUserId: string;
}

export interface RequestGetAllFranchiseeDetails {}

export interface RequestGetConvertedQuoteTotals {
  startDate: string;
  endDate: string;
  branchIds: string[];
  userId: string;
}

export interface RequestGetFranchiseeDetails {
  deploymentFranchiseeConfigurationId: string;
}

export interface RequestGetGeneratedPurchaseOrderRevenue {
  startDate: string;
  endDate: string;
  branchIds: string[];
  assignedToUserId: string;
}

export interface RequestGetGeneratedQuoteRevenue {
  startDate: string;
  endDate: string;
  branchIds: string[];
  assignedToUserId: string;
}

export interface RequestGetLastRowVersion {
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  deploymentId: number;
}

export interface RequestGetPurchaseOrderList {
  pageIndex: number;
  pageSize: number;
  sortField: string;
  sortAsc: boolean;
  branchId: string;
  assignedToUserId: string;
}

export interface RequestGetQuoteList {
  count: number;
  state: number;
}

export interface RequestGetSupportInbox {
  requestPage: RequestPaginated;
  ticketOwnerFilter: SupportInboxTicketOwnerFilter;
  typeFilter: SupportInboxItemType;
  statusFilter: SupportInboxItemStatus;
  filter: string | null;
  sortField: string | null;
  sortAsc: boolean;
}

export interface RequestOnBoardTenant {
  companyName: string | null;
  businessPhone: string | null;
  reference: string | null;
  licensePoolId: number;
  licenseAllocation: number;
  deploymentId: number;
  initialUserName: string | null;
  initialUserEmail: string | null;
  initialName: string | null;
  initialPhone: string | null;
  initialJobTitle: string | null;
}

export interface RequestPAT {
  dealerDeploymentId: number;
  tenantId: number;
  preferredLifeOfTokenHours: number | null;
  claims: { [key: string]: string } | null;
}

export interface RequestPaginated {
  pageSize: number;
  pageIndex: number;
}

export interface ResultAddQuoteSupportRequest {
  supportInboxItem: SupportInboxItem;
  state: AddQuoteSupportRequestState;
}

export interface ResultAddQuoteSupportRequestServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultAddQuoteSupportRequest | null;
}

export interface ResultCreateFranchisee {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
}

export interface ResultCreateFranchiseeServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultCreateFranchisee | null;
}

export interface ResultCurrentRecordVersion {
  recordVersion: string;
}

export interface ResultCurrentRecordVersionServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultCurrentRecordVersion | null;
}

export interface ResultDataExportFranchisees {
  deployments: ViewDeploymentExport[];
  supplierUsers: ViewSupplierUserExport[];
}

export interface ResultDataExportFranchiseesServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultDataExportFranchisees | null;
}

export interface ResultDataExportPurchaseOrders {
  purchaseOrders: PurchaseOrderAggregated[];
}

export interface ResultDataExportPurchaseOrdersServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultDataExportPurchaseOrders | null;
}

export interface ResultDataExportQuotes {
  quotes: QuoteAggregated[];
}

export interface ResultDataExportQuotesServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultDataExportQuotes | null;
}

export interface ResultGetActiveUserInformation {
  globalSupplier: GlobalSupplierReference;
  userClaims: { [key: string]: string };
}

export interface ResultGetActiveUserInformationServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetActiveUserInformation | null;
}

export interface ResultGetAllFranchiseeDetails {
  tenantList: ResultTenantList;
  franchisees: DeploymentFranchiseeConfiguration[];
  branches: DeploymentFranchiseeBranch[];
  branchReferences: ResultGetSupplierReferenceCodeOnTenant[];
}

export interface ResultGetAllFranchiseeDetailsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetAllFranchiseeDetails | null;
}

export interface ResultGetConvertedQuoteTotals {
  quoteCount: number;
  purchaseOrderCount: number;
}

export interface ResultGetConvertedQuoteTotalsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetConvertedQuoteTotals | null;
}

export interface ResultGetFranchiseeDetails {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
  tenantList: ResultTenantList;
  branches: DeploymentFranchiseeBranch[];
}

export interface ResultGetFranchiseeDetailsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetFranchiseeDetails | null;
}

export interface ResultGetGeneratedPurchaseOrderRevenue {
  revenueSummary: ViewDailyRevenue[];
  startDate: string;
  endDate: string;
}

export interface ResultGetGeneratedPurchaseOrderRevenueServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetGeneratedPurchaseOrderRevenue | null;
}

export interface ResultGetGeneratedQuoteRevenue {
  revenueSummary: ViewDailyRevenue[];
  startDate: string;
  endDate: string;
}

export interface ResultGetGeneratedQuoteRevenueServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetGeneratedQuoteRevenue | null;
}

export interface ResultGetLastRowVersion {
  quoteRowVersion: string;
  purchaseOrderRowVersion: string;
  quoteOwnerIds: string[];
}

export interface ResultGetLastRowVersionServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetLastRowVersion | null;
}

export interface ResultGetPurchaseOrderList {
  purchaseOrders: PurchaseOrderSummary[];
  totalCount: number;
}

export interface ResultGetPurchaseOrderListServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetPurchaseOrderList | null;
}

export interface ResultGetQuoteList {
  quotes: QuoteAggregated[];
}

export interface ResultGetQuoteListServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetQuoteList | null;
}

export interface ResultGetSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeplymentId: number;
  referenceOverrides: { [key: string]: string } | null;
}

export interface ResultGetSupportInbox {
  items: ViewSupportInboxItemExResultPaginated;
}

export interface ResultGetSupportInboxServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetSupportInbox | null;
}

export interface ResultPAT {
  pat: string | null;
}

export interface ResultPATServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultPAT | null;
}

export interface ResultSetNewQuotesAndPurchaseOrdersForSupplier {
  quotesUpdated: number;
  purchaseOrdersUpdated: number;
}

export interface ResultSetNewQuotesAndPurchaseOrdersForSupplierServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultSetNewQuotesAndPurchaseOrdersForSupplier | null;
}

export interface ResultSyncBranches {}

export interface ResultSyncBranchesServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultSyncBranches | null;
}

export interface ResultTenantList {
  deployments: ViewDeploymentTenants[] | null;
  tenants: Tenant[] | null;
  globalSupplierSupplierId: string;
  globalSupplierId: number;
}

export interface ResultUpdateFranchiseeDeploymentConfiguration {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
}

export interface ResultUpdateFranchiseeDeploymentConfigurationServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultUpdateFranchiseeDeploymentConfiguration | null;
}

export interface ResultUpdateFranchiseeSupplierProperties {}

export interface ResultUpdateSupplierReferenceCodeOnTenant {}

export interface ResultUpdateSupportInboxItem {
  supportInboxItem: SupportInboxItem;
  viewSupportInboxItem: ViewSupportInboxItemEx;
}

export interface ResultUpdateSupportInboxItemServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultUpdateSupportInboxItem | null;
}

export interface ServiceResponseError {
  message: string;
  stackTrace: string | null;
}

export enum ServiceResponseType {
  None = 0,
  Ok = 1,
  NotFound = 2,
  UnAuthenticated = 4,
  UnAuthorized = 8,
  Error = 16,
  TransientDbError = 32,
  ValidationFailure = 64,
  ModifyNotFound = 128
}

export interface SupplierTenantInfo {
  tenantId: number;
  allowSupplierSupportAccess: boolean;
  reference: string | null;
  licensePoolAllocations: number;
  licensePoolAllocated: number;
  state: TenantInitializationState;
  primaryContact: BaseLogin | null;
}

export interface SupportInboxItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  globalSupplierReferenceId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  conversationId: string;
  branchId: string;
  quoteId: string;
  quoteSetId: string;
  franchiseeSystemUserId: string;
  type: SupportInboxItemType;
  status: SupportInboxItemStatus;
  lastModified: string;
  lastModifiedUserId: string;
  assignedToUserDateTime: string | null;
  assignedUserId: string;
  subject: string;
  note: string | null;
  other: { [key: string]: string };
}

export enum SupportInboxItemStatus {
  All = 0,
  New = 1,
  Overdue = 2,
  Active = 4,
  Resolved = 8,
  Cancelled = 16,
  ReActivated = 32
}

export enum SupportInboxItemType {
  All = 0,
  Basic = 1,
  QuoteReview = 2,
  EngineeredToOrder = 4,
  QuoteAssistanceRequest = 8
}

export enum SupportInboxTicketOwnerFilter {
  All = 0,
  Mine = 1,
  Unassigned = 2
}

export interface SystemViewLicensePool {
  licensePool: DeploymentTenantLicensePool | null;
  availableUsers: number;
  availableAllocations: number;
}

export interface Tenant {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  companyName: string | null;
  primaryContact: string | null;
  primaryContactPhoneNumber: string | null;
  primaryContactEmail: string | null;
  claims: { [key: string]: string } | null;
  physicalAddress: Address | null;
}

export enum TenantInitializationState {
  Available = 0,
  RequestedBySupplier = 1,
  PendingDelivery = 2,
  Disabled = 4
}

export interface ViewDailyRevenue {
  date: string;
  dailyRevenue: number;
}

export interface ViewDeploymentExport {
  dealerDeploymentId: number;
  dealerDeploymentName: string;
  uiDomain: string;
  franchisees: ViewFranchiseeExport[];
}

export interface ViewDeploymentTenants {
  dealerDeploymentId: number;
  name: string | null;
  uiDomain: string | null;
  tenants: SupplierTenantInfo[] | null;
  userLoginInformation: ViewUserLoginInformation[] | null;
  licensePools: SystemViewLicensePool[] | null;
}

export interface ViewFranchiseeBranchExport {
  name: string;
  abbreviation: string;
  physicalAddress: Address | null;
  billingAddress: Address | null;
  v6CustomerCode: string;
  readonly id: string;
}

export interface ViewFranchiseeExport {
  id: number;
  name: string;
  defaultV6CustomerCode: string;
  branches: ViewFranchiseeBranchExport[];
  users: ViewSystemUserExport[];
  licensesProvided: number;
  licensesUsed: number;
}

export interface ViewSupplierUserExport {
  systemUserId: string;
  userName: string;
  displayName: string;
  emailAddress: string;
}

export interface ViewSupportInboxItemEx {
  item: SupportInboxItem;
  title: string | null;
  state: number;
  quoteNumber: number;
  quoteSuffix: string;
  quoteType: number;
  quoteLastModified: string;
  quoteLastModifiedUserId: string;
  quoteAssignedToUserId: string;
}

export interface ViewSupportInboxItemExResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewSupportInboxItemEx[];
}

export interface ViewSystemUserExport {
  systemUserId: string;
  userName: string;
  displayName: string;
  emailAddress: string;
  active: boolean;
  lastLoginTime: string | null;
  branchAccess: string[];
  isAdmin: boolean;
  isPrimaryContact: boolean;
  isBranchAdmin: boolean;
  readonly canAccessAllBranches: boolean;
}

export interface ViewUserLoginInformation {
  tenantId: number;
  tenantLoginId: number;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  active: boolean;
  lastLoginTime: string | null;
  claims: { [key: string]: string } | null;
  systemUserId: string;
}
